export default __webpack_public_path__ + "static/media/customer-img.23aa9496.webp";